import { render, staticRenderFns } from "./Step-1-healthcare.vue?vue&type=template&id=c5a530d2&scoped=true&"
import script from "./Step-1-healthcare.vue?vue&type=script&lang=js&"
export * from "./Step-1-healthcare.vue?vue&type=script&lang=js&"
import style0 from "./Step-1-healthcare.vue?vue&type=style&index=0&id=c5a530d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a530d2",
  null
  
)

export default component.exports